module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-20@2x-758bf7f328c6c93de6d5764b2a78c4bb.png";